enum ContractPeriodFilterType {
  NONE = 'NONE',
  PERIOD_STARTED = 'PERIOD_STARTED',
  PERIOD_CANCELED = 'PERIOD_CANCELED',
  PERIOD_INACTIVATED = 'PERIOD_INACTIVATED',
}

const contractPeriodFilterTypeOptions = [
  { text: 'Período de Início', value: 'PERIOD_STARTED' },
  { text: 'Período de Cancelamento', value: 'PERIOD_CANCELED' },
  { text: 'Período de Inativação', value: 'PERIOD_INACTIVATED' },
]

export {
  ContractPeriodFilterType,
  contractPeriodFilterTypeOptions,
}
